import { React } from 'react';
import { createRoot } from 'react-dom/client'
import './index.scss';
import MainApp from './components/App/App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<MainApp />);
